import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageBranchLayer from "../../../components/Admin/ManageBranchLayer";

const ManageBranch = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Manage Branch' />

        {/* BlankPageLayer */}
        <ManageBranchLayer />
      </MasterLayout>
    </>
  );
};

export default ManageBranch;
